<!--
 * @description: 顶部 Tab
 * @Author: Jay
 * @Date: 2021-09-17 10:07:38
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-19 14:49:35
-->
<template>
  <div class="wdith-max">
    <div class="tap-header flex align-center">
      <!-- log -->
      <router-link to="/Home">
        <el-image class="log-img" :src="logImg" fit="fill"></el-image>
      </router-link>
      <!-- tab栏 -->
      <div class="tap-left">
        <el-dropdown
          class="tap-code"
          @command="handleCommand"
          v-for="(item, index) in tabList"
          :key="index"
          :disabled="index == 0"
        >
          <!-- 一级标题 -->
          <div
            class="flex flex-direction padding-top-sm"
            @click="skipTap(index)"
            @mouseover="mouseOver(index)"
          >
            <span class="text-white font_size_df_top"> {{ item.name }}</span>
          </div>
          <!-- 下拉菜单 -->
          <el-dropdown-menu slot="dropdown" v-if="item.data !== undefined">
            <!-- <el-dropdown-menu slot="dropdown" v-show="index != 0"> -->
            <!-- <template v-if="item.data !== undefined"> -->
            <el-dropdown-item
              :command="twoId"
              v-for="(two, twoId) in item.data"
              :key="twoId"
            >
              {{ two.name }}
            </el-dropdown-item>
            <!-- </template> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { banben, nav } from "../../api/api";
export default {
  name: "topTap",
  data() {
    return {
      //log 图片
      logImg: "",
      //  tab 切换
      tabId: 0,
      //一级标题
      tabList: [],
      //二级目录
      levelList: [],
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      //获取Log
      banben().then((res) => {
        // console.log(res);
        let img = res.data[2].value;
        this.logImg = this.$api + img;
      });
      //导航栏
      nav().then((res) => {
        // console.log(res);
        this.tabList = res.data;
      });
    },
    //二级目录 点击
    handleCommand(command) {
      // console.log(command);
      let index = this.tabId;
      switch (index) {
        case 0:
          // 首页
          break;
        case 1:
          // 自然科普馆
          this.goTo({
            path: "/NatureCoupe",
            query: { index: command },
          });
          break;
        case 2:
          //科普巡展
          this.goTo({
            path: "/Roadshow",
            query: { index: command },
          });
          break;
        case 3:
          //互动体验
          this.goTo({
            path: "/Interactive",
            query: { index: command },
          });
          break;
        case 4:
          //科普文创
          this.goTo({
            path: "/Cultural",
            query: { index: command },
          });
          break;
        case 5:
          //科普殿堂
          this.goTo({
            path: "/Palace",
            query: { index: command },
          });
          break;
        case 6:
          //宝藏鉴赏
          this.goTo({
            path: "/Treasure",
            query: { index: command },
          });
          break;
        case 7:
          //逛博物馆
          this.goTo({
            path: "/StrollMuseum",
            query: { index: command },
          });
          break;
        case 8:
          // 关于我们
          if (command == 0) {
            // 企业简介
            this.goTo({ path: "/AboutUs" });
          } else if (command == 1) {
            // 科普践行
            this.goTo({ path: "/AboutCoupe" });
          } else {
            // 联系我们
            this.goTo({ path: "/ContactUS" });
          }
          break;
        // default:
        //   this.secondShow = true;
        //   break;
      }
    },
    //移入
    mouseOver(index) {
      // console.log("鼠标移入", index);
      this.tabId = index;
    },
    //循环添加 url
    forAdd(list, url) {
      list.map((item, index) => {
        // console.log(item, index);
        this.$set(item, "url", {
          path: url,
          query: { index: index },
        });
      });
      return list;
    },
    //一级标题 页面跳转
    skipTap(index) {
      // console.log(index);
      switch (index) {
        case 0:
          // name: "首页",
          this.goTo({ path: "/Home" });
          break;
        case 1:
          // name: "自然科普馆",
          this.goTo({ path: "/NatureCoupe" });
          break;
        case 2:
          //  name: "科普巡展",
          this.goTo({ path: "/Roadshow" });
          break;
        case 3:
          //  name: "互动体验",
          this.goTo({ path: "/Interactive" });
          break;
        case 4:
          // name: "科普文创",
          this.goTo({ path: "/Cultural" });
          break;
        case 5:
          //  name: "科普殿堂",
          this.goTo({ path: "/Palace" });
          break;
        case 6:
          //  name: "宝藏鉴赏",
          this.goTo({ path: "/Treasure" });
          break;
        case 7:
          // name: "逛博物馆",
          this.goTo({ path: "/StrollMuseum" });
          break;
        case 8:
          // name: "关于我们",
          this.goTo({ path: "/AboutUs" });
          break;
      }
    },
    //集体跳转
    goTo(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style>
/* 修改 默认element 默认css */
.el-dropdown [disabled] {
  /* cursor: not-allowed; */
  cursor: default;
  /* color: #bbb; */
}

/* 下拉框 文字颜色 */
.el-dropdown-menu__item {
  color: #fff;
}
/* 下拉框 选中颜色 */
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #dadada !important;
  color: #333333 !important;
}
/* 下拉框 背景色 */
.el-dropdown-menu {
  background-color: #9d8540;
  border: 0.0625rem solid #9d8540;
  color: #ffff;
}
/* 下拉框 三角形 */
.el-popper .popper__arrow::after {
  /* background-color: #9d8540; */
  border-bottom: 5px solid #9d8540 !important;
}
</style>
<style lang="scss" scoped>
///最大宽度
.wdith-max {
  // width: 1920px;
  width: 100vw;
  min-width: 1280px;
  position: sticky;
  top: 0;
  z-index: 1111;
}
// tab栏
.tap-header {
  height: 75px;
  // width: 100%;
  background-color: #000000d4;
  // opacity: 0.6;
  color: #ffffff;
  // log
  .log-img {
    // height: 90%;
    padding-left: 100px;
    width: 212px;
    margin: 20px 0 10px 0;
    max-width: 212px;
  }

  //tap栏
  .tap-left {
    // background-color: aliceblue;
    padding-left: 400px;
    margin: 0 auto;
    .tap-code {
      //鼠标事件
      cursor: default;
      padding: 20px;
    }
  }
}
</style>